import { Button, Text } from '@mercator-gcp/grout';
import { Link } from 'react-router-dom';
import { EmptyField } from 'components/elements/EmptyField';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { LandTitle } from 'types/LandTitle';

const historyLink = {
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};

const companyText = {
  textTransform: 'capitalize',
};

type Props = {
  landTitleHistory: LandTitle[] | undefined;
  handleTabClick?: (index: number) => void;
};

const LandTitleRequests = ({ landTitleHistory, handleTabClick }: Props) => {
  const unitAction = () => {
    if (handleTabClick) {
      handleTabClick(1);
    }
  };

  if (!landTitleHistory || landTitleHistory.length === 0) {
    return <EmptyField />;
  }

  if (landTitleHistory && landTitleHistory.length === 1) {
    return (
      <FlexColumn>
        {landTitleHistory[0].companies.map((company) => {
          if (company.uuid) {
            return (
              <Link to={`/companies/${company.uuid}`} key={company.uuid}>
                <Button variant="unstyled" onClick={unitAction}>
                  <Text.Body sx={{ ...historyLink, ...companyText }}>
                    {company.name}
                  </Text.Body>
                </Button>
              </Link>
            );
          }

          return (
            <Text.Body key={company.name} sx={companyText}>
              {company.name}
            </Text.Body>
          );
        })}
      </FlexColumn>
    );
  }

  return (
    <Button variant="unstyled" onClick={unitAction}>
      <Text.BodyBold sx={{ ...historyLink, ...companyText }}>
        {landTitleHistory.length} Unit Owners
      </Text.BodyBold>
    </Button>
  );
};

export default LandTitleRequests;
